import React from "react";
import { format as dateFormat } from "date-fns";
import { useMemo } from "react";

export const OrderActionCenterDetailsDisplay = ({ orderInfo }) => {
  return (
    <>
      <div className="paper-panel sub-panel">
        <address>
          <span className="h5">
            {orderInfo?.customerName ?? "Customer Name Not Found"}
          </span>
          <p className="m-1">
            {orderInfo?.customerAddress
              ? `${orderInfo?.customerAddress} ${orderInfo?.customerCity}, ${orderInfo?.customerState} ${orderInfo?.customerZip}`
              : "Customer Address Not Found"}
          </p>
          <p className="m-1">
            {"Phone: " +
              (orderInfo?.customerPhoneNumber
                ? orderInfo?.customerPhoneNumber
                : "Not Found")}
          </p>
        </address>
      </div>
      <div className="paper-panel sub-panel">
        <div className="row">
          <div className="col-12 h5">Delivery #{orderInfo?.deliveryId}</div>
          {/* <div className="col-6 text-right h5">
            - {orderInfo?.status ?? "N/A"} -
          </div> */}
          {/* <div className="col-6 h5">
            Invoice #{orderInfo?.invoiceNumber ?? "N/A"}
          </div>
          <div className="col-6 text-right h5 text-note">
            {orderInfo?.route ?? "N/A"}
          </div> */}
          <div className="col-md-6">
            <span className="font-500">Invoice Number:</span>
            <br />
            <span className="ml-md-1">{orderInfo?.invoiceNumber}</span>
          </div>
          <div className="col-md-6">
            <span className="font-500">Route:</span>
            <br />
            <span className="ml-md-1">{orderInfo?.route}</span>
          </div>
          <div className="col-md-6">
            <span className="font-500">Creation Date: </span>
            <br />
            <span className="ml-md-1">
              {orderInfo?.creationDate
                ? dateFormat(new Date(orderInfo.creationDate), "MM/dd/yyyy")
                : "Not Found"}
            </span>
          </div>
          <div className="col-md-6">
            <span className="font-500">Delivery Date: </span>
            <br />
            <span className="ml-md-1">
              {orderInfo?.creationDate
                ? dateFormat(new Date(orderInfo.deliveryDate), "MM/dd/yyyy")
                : "Not Found"}
            </span>
          </div>
          {orderInfo?.isCod === true && (
            <>
              <div className="col-md-6">
                <span className="font-500">COD Amount: </span>
                <br />
                <span className="ml-md-1">{orderInfo?.codAmount}</span>
              </div>
              <div className="col-md-6">
                <span className="font-500">COD Date: </span>
                <br />
                <span className="ml-md-1">
                  {new Date(
                    orderInfo?.codDetails?.codDate
                  ).toLocaleDateString()}
                </span>
              </div>
            </>
          )}
          <div className="col-12">
            <span className="font-500">Comments:</span> <br />
            <span className="ml-md-1">
              {orderInfo?.comment ? orderInfo?.comment : "None"}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
